var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingAvatarBob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 136.374C36.417 136.374 7.62589 107.54 7.62589 71.9999C7.62589 36.4169 36.4596 7.62578 72.0002 7.62579C107.583 7.62579 136.374 36.4596 136.374 71.9999C136.417 107.583 107.583 136.374 72.0002 136.374Z",
    fill: "#B5E2DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6071_8125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 130,
    height: 130
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 136.374C36.417 136.374 7.62589 107.54 7.62589 71.9999C7.62589 36.4169 36.4596 7.62578 72.0002 7.62579C107.583 7.62579 136.374 36.4596 136.374 71.9999C136.417 107.583 107.583 136.374 72.0002 136.374Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6071_8125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.594 121.231C114.323 121.482 114.009 121.737 113.738 121.989C113.425 122.245 113.154 122.495 112.835 122.709C112.558 122.917 112.325 123.12 112.048 123.328C112.011 123.377 111.968 123.381 111.931 123.43C111.028 124.15 110.076 124.833 109.119 125.474C108.843 125.682 108.524 125.896 108.242 126.061C108.242 126.061 108.205 126.109 108.163 126.115C107.844 126.328 107.525 126.542 107.206 126.756C106.568 127.183 105.882 127.573 105.239 127.957C104.92 128.171 104.553 128.347 104.228 128.518C103.904 128.689 103.542 128.908 103.218 129.079C102.894 129.249 102.532 129.468 102.208 129.64C102.208 129.64 102.208 129.64 102.165 129.646C101.841 129.816 101.474 129.992 101.15 130.164C100.416 130.516 99.6392 130.875 98.9054 131.227C98.6608 131.345 98.3735 131.468 98.1289 131.586C97.3525 131.944 96.5706 132.259 95.7833 132.533C95.4961 132.655 95.2035 132.736 94.8737 132.864C94.129 133.132 93.3418 133.405 92.597 133.672C92.4322 133.737 92.3045 133.753 92.1396 133.817C91.8895 133.892 91.5969 133.973 91.3469 134.048C90.9691 134.139 90.6393 134.268 90.2616 134.359C90.0967 134.423 89.9264 134.445 89.7615 134.508C89.5541 134.579 89.304 134.653 89.0486 134.686C88.3782 134.858 87.6653 135.034 86.9949 135.207C86.7875 135.276 86.532 135.309 86.3245 135.378L86.282 135.384C85.9893 135.464 85.6913 135.502 85.3987 135.582C85.1061 135.662 84.8081 135.701 84.5101 135.738C84.3398 135.76 84.1323 135.829 83.9621 135.851C83.6215 135.895 83.3288 135.975 83.0308 136.013C82.6051 136.067 82.2273 136.158 81.8016 136.212C81.3758 136.266 80.9926 136.315 80.567 136.369C80.2689 136.407 79.9709 136.444 79.6729 136.482C61.7168 138.504 44.5707 132.939 31.5394 122.308C31.5394 122.308 31.5345 122.265 31.4919 122.27C32.4813 119.506 36.7824 114.201 41.3996 109.678C47.2486 103.959 56.018 99.774 56.018 99.774C56.018 99.774 61.8966 98.0321 84.7523 99.8443C102.194 101.263 111.275 114.86 114.594 121.231Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9759 111.036C90.6389 115.536 85.1788 118.867 74.9318 116.189C62.352 112.856 56.0179 99.774 56.0179 99.774C54.1354 90.0628 51.5799 81.8651 51.5799 81.8651C65.2649 78.9153 83.6685 93.0166 83.6685 93.0166L86.5586 100.782C86.8154 101.442 87.2317 101.994 87.7967 102.356C88.8854 103.775 91.215 108.151 90.9759 111.036Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8026 102.398C79.6169 103.006 73.4625 102.576 65.5683 91.8549C71.6289 95.9735 78.2901 96.9875 85.1675 96.979L86.5591 100.782C86.8213 101.484 87.2377 102.037 87.8026 102.398Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1022 48.9604C99.3228 52.4391 100.074 55.2856 99.1991 65.0871C98.3244 74.8887 103.538 83.9169 94.5991 93.9208C88.5762 100.656 76.8813 103.266 66.6132 98.0385C63.1443 96.2728 59.8227 93.6232 56.9356 89.9668C54.6676 87.0968 52.1231 84.4351 49.3557 82.0611C45.5272 78.8271 40.5468 71.9756 40.8935 58.6937C41.4352 37.0808 62.116 31.9879 74.8025 32.7556C87.489 33.5233 94.8154 39.7739 98.1022 48.9604Z",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4738 70.7826C59.4738 70.7826 57.3427 64.5641 51.2243 66.1201C45.9465 67.4826 45.7066 80.5779 58.337 82.6074",
    fill: "#F7D3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2126 76.8232C57.2126 76.8232 55.5557 76.0388 55.5096 74.3141C55.5108 72.2807 55.0985 71.0785 54.1133 70.8143C51.6473 70.1326 51.5251 72.9168 51.6535 73.2466",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2207 76.8264C90.2207 76.8264 91.8494 76.7061 93.1494 74.6807C93.8711 73.5507 94.4327 72.1816 93.9157 71.8579C93.3933 71.4917 85.8388 73.6627 85.4577 74.7493C85.0766 75.836 88.2623 77.0752 90.2207 76.8264Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6806 62.3596C89.6806 62.3596 90.2796 66.3933 93.4499 70.5763C94.8535 72.4311 93.5245 75.9311 89.8057 76.966",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M68.6993 81.7667C71.1212 81.459 72.8787 79.5894 72.6248 77.5908C72.3709 75.5922 70.2018 74.2214 67.78 74.529C65.3581 74.8367 63.6007 76.7064 63.8545 78.7049C64.1085 80.7035 66.2776 82.0743 68.6993 81.7667Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M99.2095 70.623C99.3847 73.0233 99.7247 75.3595 99.8519 77.7228C97.9245 77.535 96.3837 76.3031 96.1727 74.6427C95.9456 72.8546 97.2518 71.2178 99.2095 70.623Z",
    fill: "#ED938A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.18 145.853L24.5523 159.525C24.5523 159.525 22.5003 139.627 27.363 124.776C30.9392 113.766 42.789 106.247 51.1756 102.11C53.0474 101.18 54.7706 100.443 56.1695 99.875C56.8 101.093 63.1158 113.009 75.0246 116.169C85.277 118.889 90.7317 115.514 91.0688 111.016C91.2652 108.136 88.9356 103.759 87.8522 102.383C87.2873 102.022 86.8656 101.426 86.6142 100.809L86.0951 99.4482C86.8398 99.1798 87.5365 98.8752 88.2758 98.5651C88.6698 98.6015 89.0637 98.6381 89.4577 98.6745C95.1174 99.2967 103.655 101.457 114.213 108.291C126.408 116.086 132.18 145.853 132.18 145.853Z",
    fill: "#FF7E55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0721 122.401C92.636 123.016 86.7551 118.269 85.5718 117.467C84.7333 118.699 78.826 127.366 75.3551 127.287C71.5384 127.21 61.1425 121.998 55.0074 112.525C51.6221 107.331 51.1097 103.978 51.1751 102.11C51.1947 101.243 51.3798 100.656 51.4697 100.342C51.771 99.3085 54.355 95.1303 55.1267 95.0756L55.1322 95.1181C56.0346 99.157 57.8573 102.948 60.5092 106.115C63.7694 109.984 68.7129 114.504 75.0242 116.169C85.2766 118.889 89.8453 114.328 90.1397 109.835C90.3362 106.955 88.9351 103.759 87.8519 102.383C87.2868 102.022 86.8651 101.426 86.6137 100.809L86.0946 99.4482C86.8393 99.1798 87.536 98.8752 88.2753 98.565C88.4774 98.4528 88.7274 98.3778 88.9295 98.2655C89.0788 98.4196 89.2708 98.5683 89.4201 98.7224C91.4678 100.539 93.698 103.111 95.3256 107.749C98.0392 115.149 95.6675 121.679 94.0721 122.401Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4116 117.228C85.4116 117.228 88.7467 118.622 88.8508 120.122C88.955 121.624 90.4493 126.236 90.4493 126.236",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0888 122.896C86.6531 122.825 87.0524 122.309 86.9807 121.744C86.909 121.18 86.3934 120.781 85.8291 120.853C85.2648 120.924 84.8655 121.44 84.9372 122.004C85.0089 122.568 85.5244 122.968 86.0888 122.896Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9797 126.849C87.544 126.777 87.9433 126.261 87.8716 125.698C87.7999 125.133 87.2843 124.734 86.7201 124.806C86.1558 124.877 85.7564 125.393 85.8281 125.957C85.8998 126.522 86.4154 126.921 86.9797 126.849Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.273 126.246C117.273 126.246 116.39 129.516 117.168 132.575C117.946 135.634 119.632 140.049 118.982 147.529",
    stroke: "#544D4D",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6154 64.9736C77.6154 64.9736 74.6406 65.3948 71.3312 63.5223",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3464 64.0487C90.3464 64.0487 93.3414 63.1059 94.084 61.8002",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2427 61.4359C80.1111 61.8015 81.0517 61.033 80.9699 60.0485C80.9051 59.5376 80.7496 58.995 80.3495 58.5699C79.1547 57.3374 73.9085 55.884 70.5736 57.2162C67.6907 58.361 75.2684 59.7777 79.2427 61.4359Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3779 60.2862C91.8414 60.8302 90.7918 60.4011 90.5506 59.5233C90.406 59.0658 90.3836 58.5495 90.5423 58.0967C91.0613 56.733 93.99 54.5872 96.6526 55.1142C98.9692 55.6419 94.9653 57.8377 92.3779 60.2862Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6202 64.1371C72.3175 64.4784 72.1642 64.9737 72.181 65.4474L72.2899 66.645C72.3771 67.6721 73.2516 68.4263 74.2362 68.3445C75.2634 68.2572 76.0176 67.3827 75.9357 66.3981L75.8268 65.2006C75.8215 65.1581 75.8161 65.1155 75.8106 65.0729C74.6929 65.1283 73.6542 64.7845 72.6202 64.1371Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3358 63.9632C90.3412 64.0058 90.3412 64.0058 90.3466 64.0484L90.4447 65.1607C90.521 66.1027 91.3476 66.8198 92.2896 66.7433C93.2317 66.667 93.9486 65.8404 93.8722 64.8984L93.7742 63.7861C93.7626 63.3549 93.5436 62.9934 93.293 62.7224C92.4266 63.3949 91.4211 63.6524 90.3358 63.9632Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8763 82.0103C88.883 82.7448 88.9054 83.2611 88.8317 83.7031C88.6075 86.0244 87.4451 85.0473 85.5772 85.3278C83.2411 85.6678 79.5258 88.4327 78.2903 85.5181C78.0497 84.9863 77.8997 84.4862 77.7976 84.0233C76.831 79.82 81.1817 80.6949 85.5595 81.7827C87.2639 82.2584 88.291 82.1711 88.8763 82.0103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.874 83.6978L87.7082 83.7155",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8595 81.2364C89.8595 81.2364 89.4528 82.8021 85.565 81.8251C80.6492 80.5893 75.7342 79.6996 78.2957 85.5605C79.5683 88.4271 83.2465 85.7104 85.5827 85.3703C87.7911 85.0465 89.0076 86.4494 88.8817 82.0527",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7972 84.0231C78.2337 84.0541 80.5097 82.8998 81.1659 83.6384C81.8221 84.377 82.4114 83.5668 82.7682 83.6511C83.1251 83.7356 84.6847 83.7538 84.6847 83.7538",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.054 40.1465C98.4214 51.472 89.5031 50.3987 80.8233 48.8191C50.2202 43.2326 58.9048 71.071 58.4566 70.6088C57.2928 68.9396 55.0106 66.9799 51.2811 67.9296C46.4236 69.1956 45.8125 80.3914 55.6245 83.7305C55.6603 85.716 54.4663 87.5548 53 88.9524C48.1923 85.8428 40.5676 79.63 36.7577 69.7313C35.3454 66.1038 35.3335 62.9473 35.4088 60.4718C35.6861 52.7794 40.1695 50.6092 40.1695 50.6092C39.3277 42.6263 46.5157 32.8014 60.5179 31.3255C74.5517 29.759 101.687 28.821 100.054 40.1465Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.066 53.2587C101.992 56.0801 101.07 58.3603 99.6097 60.1465C99.6588 55.4248 99.037 53.2542 98.1535 50.7274C96.2855 45.5572 93.1469 41.2836 88.4568 38.4186C90.5639 37.9779 92.7946 38.1704 94.9099 39.1562C94.9099 39.1562 97.9685 40.7577 99.8334 46.9234C100.407 48.7108 102.103 50.4854 102.066 53.2587Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9291 30.9357C63.9291 30.9357 79.3068 22.5796 85.2766 23.941C90.2241 25.0861 89.1377 30.1559 89.1377 30.1559C89.1377 30.1559 96.9672 27.0848 102.023 31.8069C107.079 36.529 102.883 44.027 100.307 46.9067C100.307 46.9067 105.014 47.52 105.038 51.4538C105.101 56.3775 99.5618 60.1094 99.5618 60.1094C99.5618 60.1094 101.075 55.6776 100.269 51.7135C99.4625 47.7494 99.5685 44.8374 96.263 42.3156C92.9523 39.7512 86.3217 43.4054 78.3102 40.6162C70.3412 37.8216 63.9291 30.9357 63.9291 30.9357Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9877 72.6348L72.068 73.8949C69.4709 74.2248 67.1198 72.4037 66.7899 69.8068L66.2761 65.7622C65.9462 63.1652 67.7673 60.8141 70.3643 60.4841L80.2841 59.224C82.8811 58.8941 85.2322 60.7153 85.5621 63.3122L86.0759 67.3568C86.4058 69.9537 84.5421 72.3103 81.9877 72.6348Z",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3989 57.0498L92.5029 57.6717C90.7999 57.888 89.5735 59.4716 89.7898 61.1745L90.2603 64.8784C91.1268 66.9314 92.2379 68.8668 93.7476 70.5352C93.8754 70.5189 94.0085 70.5453 94.1362 70.529L99.0322 69.9071C100.735 69.6908 101.962 68.1074 101.745 66.4044L100.902 59.7629C100.722 58.0119 99.1444 56.8281 97.3989 57.0498Z",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4592 62.5033C86.885 62.1492 88.6995 61.7889 90.2538 61.7645",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2108 65.2512L56.3769 66.8465",
    stroke: "#423232",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingAvatarBob);
export default __webpack_public_path__ + "static/media/pricing_avatar_bob.9e6192556592b47bb3d0c4251aa66e36.svg";
export { ForwardRef as ReactComponent };